/**
 * @generated SignedSource<<59841977038f0102dcf201012ce06d43>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShouldAcceptTermsAndConditionsDialogFragment$data = {
  readonly shouldAcceptTermsAndConditions: boolean;
  readonly " $fragmentType": "useShouldAcceptTermsAndConditionsDialogFragment";
};
export type useShouldAcceptTermsAndConditionsDialogFragment$key = {
  readonly " $data"?: useShouldAcceptTermsAndConditionsDialogFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShouldAcceptTermsAndConditionsDialogFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShouldAcceptTermsAndConditionsDialogFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shouldAcceptTermsAndConditions",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "41e36f2ba094b744d030010496608f0e";

export default node;
